import './shopping-cart-item.scss';

jQuery(document).ready(function () {
  jQuery('#terms-and-conditions').on('change', function () {
    if (!jQuery('#terms-and-conditions').is(':checked')) {
      jQuery('.btn-cart').addClass('disabled');
    } else {
      jQuery('.btn-cart').removeClass('disabled');
    }
  });
});
